// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-container[data-v-7b1934fc] {\n  border-radius: 5px 5px 0px 5px;\n  padding: 10px;\n  background: #FAE7E7;\n}", ""]);
// Exports
module.exports = exports;
